export default __webpack_public_path__ + "static/media/404-Error.12d6245c.gif";